export const REDUCER_INDEX = 'checkpointRoutes';

export const BASE_URL = 'checkpoint-routes';
export const CHECKPOINT_ROUTES_LIST_VIEW_STORAGE_KEY = 'checkpointRoutesList';
export const CHECKPOINT_ROUTES_LIST_PAGE_SIZE = 10;
/** Elastic name/user search is capped at 100 ids with no UI, same as Work Journey. */
export const CHECKPOINT_ROUTES_LIST_SEARCH_IDS_SIZE = 100;

export const PATHS = {
  BASE_URL,
  ACTIVE_CHECKPOINT_ROUTES: `${BASE_URL}/active`,
  CREATE_CHECKPOINT_ROUTE: `${BASE_URL}/route`,
  EDIT_CHECKPOINT_ROUTE: `${BASE_URL}/route/:divId/:routeId`,
  DETAIL_CHECKPOINT_ROUTE: `details/:divId/:routeId`,
};

export const getRouteToEditCheckpoint = (divId, routeId) =>
  PATHS.EDIT_CHECKPOINT_ROUTE.replace(':divId', divId).replace(':routeId', routeId);

export { FORMS, INIT_FILTERS } from 'packages/schedules/constants';
